// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__yIpfo","clinicsSelect":"TableHeading_clinicsSelect__nBBBD"};